import React from 'react';
import Icon from '../../../components/AppIcon';

const TraineeMetricsPanel = ({ metrics }) => {
  const metricCards = [
    {
      id: 'total',
      title: 'Total Trainees',
      value: metrics?.totalTrainees,
      subtitle: 'Active in program',
      icon: 'Users',
      iconGrad: 'from-blue-400 to-indigo-500',
      accent: 'from-blue-400 to-indigo-500'
    },
    {
      id: 'completion',
      title: 'Avg Completion',
      value: `${metrics?.avgCompletion}%`,
      subtitle: 'Across all trainees',
      icon: 'TrendingUp',
      iconGrad: 'from-emerald-400 to-teal-500',
      accent: 'from-emerald-400 to-teal-500'
    },
    {
      id: 'assessments',
      title: 'Pending Assessments',
      value: metrics?.pendingAssessments,
      subtitle: 'Awaiting review',
      icon: 'ClipboardCheck',
      iconGrad: 'from-amber-400 to-orange-500',
      accent: 'from-amber-400 to-orange-500'
    },
    {
      id: 'interviews',
      title: 'Upcoming Interviews',
      value: metrics?.upcomingInterviews,
      subtitle: 'Scheduled ahead',
      icon: 'Calendar',
      iconGrad: 'from-violet-400 to-purple-500',
      accent: 'from-violet-400 to-purple-500'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-6 sm:mb-8">
      {metricCards?.map((metric) => (
        <div
          key={metric?.id}
          className="group relative bg-card border border-border rounded-2xl p-5 sm:p-6 elevation-1 overflow-hidden transition-all duration-300 hover:-translate-y-1"
        >
          {/* colored top accent */}
          <div className={`absolute inset-x-0 top-0 h-1 bg-gradient-to-r ${metric?.accent}`} />
          <div className="flex items-center justify-between">
            <div className="min-w-0">
              <p className="text-sm font-medium text-muted-foreground mb-1 truncate">
                {metric?.title}
              </p>
              <p className="text-3xl font-bold text-foreground tracking-tight">
                {metric?.value}
              </p>
              <p className="text-xs text-muted-foreground mt-1">
                {metric?.subtitle}
              </p>
            </div>
            <div
              className={`shrink-0 w-14 h-14 rounded-2xl bg-gradient-to-br ${metric?.iconGrad} flex items-center justify-center shadow-md transition-transform duration-300 group-hover:scale-110`}
            >
              <Icon name={metric?.icon} size={26} className="text-white" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TraineeMetricsPanel;